/* eslint-disable react/jsx-one-expression-per-line */
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  Drawer,
  Spin,
  Tag,
  Empty,
  Select,
  Form,
  Button,
  message,
  Radio,
  Input,
  Tooltip,
  Modal,
  Row,
  Col,
} from 'antd';

import CompleteAudio from 'Components/common/completeAudio';
import SegmentedSpeech from 'Components/common/segmentedSpeech';
import moment from 'moment';
import tDetailActions from 'Actions/taskManage/detail';
import robot from 'Static/images/robot.png';
import user from 'Static/images/yonghu.png';
import timeFormat from 'Utils/timeFormat';
import './index.less';

const { Option } = Select;
const { TextArea } = Input;
const { confirm } = Modal;
const qaTypeMap = {
  QA: '类型',
  scen: '场景',
  normalQa: '正常库',
  abnormalQa: '异常库',
  ceaseQa: '停止库',
  error: '异常兜底',
};

class DetailDrawer extends Component {
  constructor(props) {
    super(props);
    const { answersList = [] } = this.props

    this.state = {
      id: '',
      transferCallDuration: '0:00:00', // 左侧通话时长-转换后
      callDuration: 0, // 录音时长-转换前
      playId: -1, // 正在播放的语音id
      choiceContentTag: '',
      choiceLabelTag: '',
      answersList,//答案列表
      answerEdit: answersList ? new Array(answersList.length).fill(0) : null,//答案编辑开关
      openMore: answersList ? new Array(answersList.length).fill(1) : null//答案展开收起开关
    };
  }

  componentDidMount() {
    this.customize = localStorage.getItem('customize');
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { id: currentId, choiceContentTag, choiceLabelTag } = prevState;
    const { id: nextId, loading, dataSource = {} } = nextProps;

    if (currentId !== nextId) {
      if (loading) {
        return {
          id: nextId,
          playId: -1,
        };
      }
      return {
        id: nextId,
      };
    }
    if (choiceContentTag === '' || choiceLabelTag === '') {
      return {
        choiceContentTag: dataSource.choiceContentTag,
        choiceLabelTag: dataSource.choiceLabelTag,
      };
    }
    return null;
  }

  // 获取左侧-通话信息-通话时长
  getCompleteAudioDuration = ({ transferCallDuration, callDuration }) => {
    this.setState({
      transferCallDuration,
      callDuration,
    });
  };

  // 分段语音
  onChangeSegmentedSpeechId = (state, playId) => {
    if (state) {
      this.setState({
        playId,
      });
    }
  };

  // 纠错标签下拉
  getTagOptions = data => {
    return Object.keys(data).map(item => {
      return (
        <Option value={item} key={item}>
          {item}
        </Option>
      );
    });
  };

  // 纠错标签保存
  saveCorrectLabel = () => {
    const { form, detailActions, id } = this.props;
    const {
      choiceContentTag,
      choiceLabelTag,
      choiceContentTagRemark,
      ...correctLabels
    } = form.getFieldsValue();
    const params = {
      jobId: id,
      correctLabels,
      choiceContentTag,
      choiceLabelTag,
      choiceContentTagRemark,
    };
    detailActions.postCorrectLabel(params).then(res => {
      const { code } = res.payload;
      if (code === 200) {
        message.success('保存成功！');
      }
    });
  };

  handleChange = (type, e) => {
    const { value } = e.target;
    if (type === 'choiceContentTag') {
      this.setState({ choiceContentTag: value });
    } else if (type === 'choiceLabelTag') {
      this.setState({ choiceLabelTag: value });
    }
  };
  //点击答案编辑
  contentItemClick = (e, i) => {
    if (e.target.className.includes('answerContent')) {
      const { answerEdit } = this.state
      answerEdit[i] = 1
      this.setState({
        answerEdit
      })
    }
  }
  //点击答案保存
  saveAnswer = (item, index) => {
    const { answersList, answerEdit } = this.state
    const { detailActions, id } = this.props;
    if (document.getElementById(`answer${index}`)) {
      answersList[index].content = document.getElementById(`answer${index}`).value
      answerEdit[index] = 0
      this.setState({ answersList, answerEdit })
      let params = {
        taskId: id,
        formQ: {
          ...item,
          contene: document.getElementById(`answer${index}`).value
        }
      }
      detailActions.setDetailDrawerAnswerData(params).then(res => {
        if (res.payload.code == 200) {
          message.success(res.payload.msg)
        } else {
          message.error(res.payload.msg)

        }
      })
    }
  }

  //答案收起展开
  openMoreClick = (e, index) => {
    const { openMore } = this.state
    openMore[index] = !openMore[index]
    this.setState({
      openMore
    })
  }
  //取消答案编辑
  cancelAnswer = (e, index) => {
    const { answerEdit } = this.state
    answerEdit[index] = 0
    this.setState({ answerEdit })

  }
  //关闭抽屉
  beforeClose = () => {
    const { onClose = () => { }, pageType, answersList } = this.props
    const { answerEdit } = this.state
    if (pageType == 'quesNaire' && answersList.length > 0 && answerEdit.filter(item => item == 1).length > 0) {
      confirm({
        title: '确定要关闭吗？',
        content: '有未保存的修改',
        onOk() {
          onClose()
        },
        onCancel() { },
      });

    } else {
      onClose()

    }
  }

  getYunWenHit = (record) => {
    const { showQuestionType, questionName, strategyType, strategyName, sceneName, slotName, slotCode, processType, questionMatchType, questionMatchContent } = record

    switch (showQuestionType) {
      case '节点':
        return (
          <div className="info-content">
            <div>命中类型：{showQuestionType}</div>
            <div>命中场景：{sceneName}</div>
            <div style={{ wordBreak: "break-all" }}>节点名称：{`${slotName}（${slotCode}）`}</div>
            <div>节点类型：{processType}</div>
            <div>匹配类型：{questionMatchType}</div>
            <div>匹配点：{questionMatchContent}</div>
          </div>
        )
        break;
      case '场景内FAQ':
        return (
          <div className='info-content'>
            <div>命中类型：{showQuestionType}</div>
            <div>场景内FAQ：{questionName}</div>
            <div>匹配类型：{questionMatchType}</div>
            <div>匹配点：{questionMatchContent}</div>
          </div>
        )
        break;
      case '通用FAQ':
        return (
          <div className='info-content'>
            <div>命中类型：{showQuestionType}</div>
            <div>通用FAQ：{questionName}</div>
            <div>匹配类型：{questionMatchType}</div>
            <div>匹配点：{questionMatchContent}</div>
          </div>
        )
        break;
      case '策略':
        return (
          <div className='info-content'>
            <div>命中类型：{showQuestionType}</div>
            <div>策略类型：{strategyType}</div>
            <div>策略名称:{strategyName}</div>
            <div>匹配类型：{questionMatchType}</div>
            <div>匹配点：{questionMatchContent}</div>
          </div>
        )
        break;

      default:
        return null
        break;
    }
  }

  needSetWidth = () => {
    const { pageType, dataSource: { nlpType = '', slotMap } = {} } = this.props
    const { answersList } = this.state
    if (pageType == 'quesNaire' && answersList && answersList.length > 0) {
      return true
    }

    if (pageType == 'detail' && nlpType == 'yunwen' && slotMap) {
      return true
    }

    return false
  }

  saveExtractField = (key) => {
    const { id, form: { getFieldValue }, onSaveExtractField = () => { } } = this.props
    let val = getFieldValue(key)

    onSaveExtractField({
      jobId: id,
      item: key,
      value: val
    })
  }

  render() {
    const {
      loading = false,
      dataSource = {},
      form: { getFieldDecorator, getFieldValue },
      login,
      lastTime = 0,
      pageType,
    } = this.props;
    const {
      id,
      transferCallDuration,
      playId,
      callDuration,
      choiceContentTag,
      choiceLabelTag,
      answerEdit,
      openMore,
      answersList,
    } = this.state;
    const { effectiveLabels = {}, correctLabels = {}, labelConf, nlpType, slotMap } = dataSource;
    const { code = {}, relation = {}, intention = {} } = labelConf || {};
    return (
      <Drawer
        className="detail-drawer call-detail-drawer"
        width="100%"
        title={`通话详情（${dataSource.callId || '暂无'}）`}
        placement="right"
        closable
        maskClosable={false}
        mask={false}
        onClose={this.beforeClose}
        visible={this.props.visible === undefined ? true : this.props.visible}
        destroyOnClose>
        <Spin spinning={loading}>
          <div className="left-content">
            <div className="left-content-item">
              <h2>通话信息</h2>
              <ul className="info-list">
                <li>第三方标识：{dataSource.clientName || '--'}</li>
                <li>客户号码：{dataSource.clientPhone || '--'}</li>
                <li>AI语料库：{dataSource.strategyName || '--'}</li>
                <li>
                  拨打次数：{dataSource.callIndex
                    ? `第${dataSource.callIndex}次`
                    : '--'}
                </li>
                <li>
                  接通时间：{dataSource.startTime
                    ? moment(dataSource.startTime).format('YYYY-MM-DD HH:mm:ss')
                    : '--'}
                </li>
                <li>通话时长：{timeFormat(lastTime, 'hour')}</li>
                <li>录音时长：{transferCallDuration || '--'}</li>
                <li>有效通话轮次：{dataSource.usefulInteractNum}</li>
                <li>通话轮次：{dataSource.interactNum}</li>
              </ul>
            </div>
            <div className="left-content-item">
              <h2>语料标签</h2>
              <div className="tag-list">
                {Array.isArray(dataSource.labels) &&
                  dataSource.labels.length > 0
                  ? dataSource.labels.map(({ labelName, color }) => (
                    <Tag className={`color-${color + 1}`}>{labelName}</Tag>
                  ))
                  : null}
              </div>
            </div>
            {dataSource.commonLabelTag ? (
              <Form className="calling-tag">

                <div className="left-content-item">
                  <h2>有效标签</h2>
                  <div className="tag-table">
                    <div className="table-header">
                      <div className="tag-type">标签分类</div>
                      <div>识别标签</div>
                    </div>
                    <div>
                      <div className="tag-type">{dataSource.nameConf ? dataSource.nameConf.default : '--'}</div>
                      <div>
                        {effectiveLabels && effectiveLabels.default
                          ? effectiveLabels.default
                          : '--'}
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            ) : null}
            {dataSource.labelTag ? (
              <Form className="calling-tag">
                <div className="left-content-item">
                  <h2>交互内容纠错</h2>
                  <Form.Item>
                    {getFieldDecorator('choiceContentTag', {
                      initialValue: dataSource.choiceContentTag || undefined,
                    })(
                      <Radio.Group
                        onChange={e =>
                          this.handleChange('choiceContentTag', e)
                        }>
                        <Radio value="right">正确</Radio>
                        <Radio value="useless">无效</Radio>
                        <Radio value="wrong">错误</Radio>
                      </Radio.Group>,
                    )}
                  </Form.Item>
                  {choiceContentTag === 'wrong' ? (
                    <Form.Item>
                      {getFieldDecorator('choiceContentTagRemark', {
                        initialValue:
                          dataSource.choiceContentTagRemark || undefined,
                      })(<TextArea rows={3} />)}
                    </Form.Item>
                  ) : null}
                </div>

                <div className="left-content-item">
                  <h2>通话标签纠错</h2>
                  <Form.Item>
                    {getFieldDecorator('choiceLabelTag', {
                      initialValue: dataSource.choiceLabelTag || undefined,
                    })(
                      <Radio.Group
                        onChange={e => this.handleChange('choiceLabelTag', e)}>
                        <Radio value="right">正确</Radio>
                        <Radio value="wrong">错误</Radio>
                      </Radio.Group>,
                    )}
                  </Form.Item>
                  <div className="tag-table">
                    <div className="table-header">
                      <div className="tag-type">标签分类</div>
                      <div>识别标签</div>
                      {choiceLabelTag === 'wrong' ? <div>纠错标签</div> : null}
                    </div>
                    <div>
                      <div className="tag-type">客户身份</div>
                      <div>
                        {effectiveLabels && effectiveLabels.relation
                          ? effectiveLabels.relation
                          : '--'}
                      </div>
                      {choiceLabelTag === 'wrong' ? (
                        <div>
                          <Form.Item>
                            {getFieldDecorator('relation', {
                              initialValue:
                                correctLabels && correctLabels.relation
                                  ? correctLabels.relation
                                  : undefined,
                            })(
                              <Select placeholder="请选择">
                                {this.getTagOptions(relation)}
                              </Select>,
                            )}
                          </Form.Item>
                        </div>
                      ) : null}
                    </div>
                    <div>
                      <div className="tag-type">还款意向</div>
                      <div>
                        {effectiveLabels && effectiveLabels.intention
                          ? effectiveLabels.intention
                          : '--'}
                      </div>
                      {choiceLabelTag === 'wrong' ? (
                        <div>
                          <Form.Item>
                            {getFieldDecorator('intention', {
                              initialValue:
                                correctLabels && correctLabels.intention
                                  ? correctLabels.intention
                                  : undefined,
                            })(
                              <Select placeholder="请选择">
                                {this.getTagOptions(intention)}
                              </Select>,
                            )}
                          </Form.Item>
                        </div>
                      ) : null}
                    </div>
                    <div>
                      <div className="tag-type">意向代码</div>
                      <div>
                        {effectiveLabels && effectiveLabels.code
                          ? effectiveLabels.code
                          : '--'}
                      </div>
                      {choiceLabelTag === 'wrong' ? (
                        <div>
                          <Form.Item>
                            {getFieldDecorator('code', {
                              initialValue:
                                correctLabels && correctLabels.code
                                  ? correctLabels.code
                                  : undefined,
                            })(
                              <Select placeholder="请选择">
                                {this.getTagOptions(code)}
                              </Select>,
                            )}
                          </Form.Item>
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <Button type="primary" onClick={this.saveCorrectLabel}>
                    保存
                  </Button>
                </div>
              </Form>
            ) : null}
          </div>

          <div className={`middle-content ${this.needSetWidth() ? 'setW' : ''}`} >
            <h2>对话详情</h2>
            <div className="video-container">
              <CompleteAudio
                source={dataSource.recordUrl || ''}
                id={id}
                getAudioDuration={this.getCompleteAudioDuration}
                reStart={loading}
                downLoadBol={login.permissionsList.includes('questionStudy.download')}
              />
            </div>
            <div className="translate-wrap">
              <div className="translate-container">
                {dataSource.records instanceof Array &&
                  dataSource.records.length > 0 ? (
                  <React.Fragment>
                    {dataSource.records.map(item => {
                      const {
                        content = '',
                        speaker = 1,
                        end = 0,
                        start = 0,
                        msgId: dialogId,
                        unknow,
                        qaType,
                        matchWords,
                        matchType,
                        question,
                        nospeak,
                        ai,
                      } = item || {};
                      let dialogTpl = null;
                      let isShowUnKnow = false;
                      let unKnowStr = '';
                      let unKnowClassName = '';

                      switch (parseInt(unknow, 10)) {
                        case 3:
                          isShowUnKnow = true;
                          unKnowStr = '已忽略';
                          break;
                        case 2:
                          isShowUnKnow = true;
                          unKnowStr = '已学习';
                          unKnowClassName = ' is-study';
                          break;
                        case 1:
                          isShowUnKnow = true;
                          unKnowStr = '未知问题';
                          unKnowClassName = ' is-unknow';
                          break;

                        default:
                          break;
                      }

                      if (speaker === 0) {
                        dialogTpl = (
                          <div className="translate-user-item">
                            <div className="img">
                              <img alt="" src={user} />
                            </div>
                            <div>
                              <div className="word-content">
                                <div className="word-video">
                                  <SegmentedSpeech
                                    id={dialogId}
                                    source={dataSource.recordUrl || ''}
                                    start={start}
                                    end={end}
                                    speaker={0}
                                    isPlay={dialogId === playId && !loading}
                                    onChange={state =>
                                      this.onChangeSegmentedSpeechId(
                                        state,
                                        dialogId,
                                      )
                                    }
                                  />
                                </div>
                                <div className="word-text">{content}</div>
                              </div>
                              {isShowUnKnow ? (
                                <div className={`unKnow${unKnowClassName}`}>
                                  <span>{unKnowStr}</span>
                                </div>
                              ) : null}
                              {nospeak ? (
                                <div className={`unKnow is-unknow`}>
                                  <span>无声问答</span>
                                </div>
                              ) : null}
                            </div>
                          </div>
                        );
                      } else {
                        dialogTpl = (
                          <div className="translate-robot-item">
                            <div>
                              <div className="word-content">
                                <div className="word-video">
                                  <SegmentedSpeech
                                    id={dialogId}
                                    source={dataSource.recordUrl || ''}
                                    start={start}
                                    end={end}
                                    speaker={1}
                                    isPlay={dialogId === playId && !loading}
                                    onChange={state =>
                                      this.onChangeSegmentedSpeechId(
                                        state,
                                        dialogId,
                                      )
                                    }
                                  />
                                </div>
                                <div className="word-text">{content}</div>
                              </div>
                              {nlpType === 'yunwen' ? (
                                this.getYunWenHit(item)
                              ) : null}

                              {this.customize === 'xy' && ai ? (
                                <div className="info-content">
                                  <div>匹配拓展问：{matchWords}</div>
                                  <div>匹配类型: {matchType}</div>
                                  <div>匹配节点：{question}</div>
                                </div>
                              ) : null}
                              {this.customize === 'xy' && nlpType === 'af' ? (
                                <div className="info-content">
                                  <div>匹配词：{matchWords}</div>
                                  <div>
                                    匹配节点：{qaType ? qaTypeMap[qaType] : ''}
                                    -
                                    {question}
                                  </div>
                                  <div>匹配规则：{matchType}</div>
                                </div>
                              ) : null}
                            </div>
                            <div className="img">
                              <img alt="" src={robot} />
                            </div>
                          </div>
                        );
                      }

                      return dialogTpl;
                    })}
                    {dataSource.startTime ? (
                      <div className="translate-end">
                        <span>
                          {`${moment(
                            dataSource.startTime + callDuration * 1000,
                          ).format('YYYY-MM-DD HH:mm:ss')} ${dataSource.transfer ? '转人工' : '结束'
                            }`}
                        </span>
                      </div>
                    ) : null}
                  </React.Fragment>
                ) : (
                  <Empty style={{ paddingTop: 100 }} />
                )}
              </div>
            </div>
          </div>
          {
            (pageType == 'detail' && nlpType == 'yunwen' && slotMap) ? (<div className="extract" style={{ float: 'right' }}>
              <div className="title">信息抽取</div>
              <div className="content">
                <Form layout='vertical'>
                  {
                    Object.entries(slotMap).map(([key, val]) => {
                      return (
                        <div className="info-item" key={key}>
                          <div className="info-input">
                            <Form.Item label={key}>
                              {getFieldDecorator(key, {
                                initialValue: val
                              })(<Input />)}
                            </Form.Item>
                          </div>
                          <div className="info-btn">
                            <Button type="primary" icon="check" disabled={slotMap[key] == getFieldValue(key)} onClick={() => {
                              this.saveExtractField(key)
                            }}></Button>
                          </div>
                        </div>
                      )
                    })
                  }
                </Form>
              </div>
            </div>) : null
          }
          {
            pageType == 'quesNaire' && answersList && answersList.length > 0 ? (
              <div className='right-content'>
                <h2>信息抽取</h2>
                {
                  answersList.map((item, index) => {
                    return (
                      <div className='answerItem' key={item.questionId}>
                        <h3>{item.question}</h3>

                        <div className={` contentItem ${answerEdit[index] ? '' : 'answerItemHover'}`} onClick={(e) => { this.contentItemClick(e, index) }}>
                          {answerEdit[index] && item.question ? (
                            <>
                              <TextArea
                                id={`answer${index}`}
                                placeholder={item.content}
                                defaultValue={item.content}
                                autoSize={{ minRows: 1, maxRows: 5 }}
                              />
                              <div className='answerBtn'>
                                <Button onClick={(e) => { this.cancelAnswer(item, index) }} size='small' style={{ marginRight: '8px' }} >
                                  取消
                                </Button>

                                <Button type="primary" style={{ marginBottom: '8px' }} onClick={(e) => { this.saveAnswer(item, index) }} size='small' >
                                  保存
                                </Button>
                              </div>
                            </>
                          ) : (
                            <Tooltip title="点击即可编辑">
                              <div className={` answerContent ${openMore[index] ? 'open' : 'close'}`}>
                                {item.content}
                                {item.content && item.content.length > 180 ? (
                                  <span onClick={(e) => { this.openMoreClick(e, index) }} className='openMore'>{openMore[index] ? '收起' : '更多'}</span>
                                ) : null}
                              </div>
                            </Tooltip>
                          )}
                        </div>
                      </div>
                    )
                  })
                }
              </div>
            ) : null
          }

        </Spin>
      </Drawer>
    );
  }
}
const mapStateToProps = (state) => ({ login: state.login });

const mapDispatchToProps = dispatch => ({
  detailActions: bindActionCreators(tDetailActions, dispatch),
});
const DetailDrawerWrap = Form.create()(DetailDrawer);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DetailDrawerWrap);
